<template>
  <section>
      <div class="mt-2 smallFolders" v-show="!showFolders">
          <b-nav vertical class="mt-2 inbox-nav">
          <div>
            <b-nav-text>
              <b-avatar size="30px"><i class="fas fa-user-alt"></i></b-avatar>
            </b-nav-text>
        
            <b-nav-item
              :to="{
                name: 'Meetings',
                params: { email: user.information.email },
              }"
              exact
              @click.prevent="closeFolders"
              v-b-tooltip.hover
              :title="user.information.email"
            >
              <i class="fal fa-inbox"></i>
            </b-nav-item>
          </div>                    
          <div>
            <div
              v-for="(item, index) in user.delegatedboxes.items"
              :key="delegatedKey(index)"
              :value="item"
            >
              <b-nav-text
                class="clickable"
              >
                <b-avatar
                  size="30px"
                  variant="secondary"
                  :text="avatarInitials(item)"
                ></b-avatar>
              </b-nav-text>
               
                <b-nav-item
                  :to="{
                    name: 'Meetings',
                    query: { user_uuid: item.user_uuid },
                    params: { email: item.email },
                  }"
                  @click.prevent="closeFolders"
                  exact
                  v-b-tooltip.hover
                  :title="item.email"
                >
                  <i class="fal fa-video"></i>
                </b-nav-item>
            </div>
          </div>
          
        </b-nav>
      </div>

      <div class="mt-2" v-show="showFolders">        
        <b-nav vertical tabs class="mt-2 inbox-nav">
          <div class="email-text">
            <b-nav-text class="mb-0 pb-0">
              &nbsp;<b-avatar size="30px" variant="secondary" class="mb-1"
                ><i class="fas fa-user-alt"></i
              ></b-avatar>
              {{ user.information.email }}
            </b-nav-text>
          </div>
          <div class="email-text">            
            <b-nav-item
            :to="{
              name: 'Meetings',
              params: { email: user.information.email },
            }"
            exact
           @click.prevent="closeFolders"
          >
            <i class="fal fa-video"></i>&nbsp;&nbsp;{{ $t("MEETINGS.TITLE") }}
          </b-nav-item>
          </div>
          <div v-if="user.delegatedboxes">
            <div
              v-for="(item, index) in user.delegatedboxes.items"
              :key="delegatedKey(index)"
              :value="item"
            >
              <div class="email-text">
                <b-nav-text
                  class="mb-0 pb-0 clickable"
                  @click="collapseDelegatedBox(item)"
                  v-b-tooltip.hover
                  :title="item.name"
                >
                  &nbsp;<b-avatar
                    size="30px"
                    variant="secondary"
                    class="mb-1"
                    :text="avatarInitials(item)"
                  ></b-avatar>
                  {{ item.name }}
                </b-nav-text>                 
                  <div class="email-text">
                    <b-nav-item
                      :to="{
                        name: 'Meetings',
                        query: { user_uuid: item.user_uuid },
                        params: { email: item.email },
                      }"
                      exact
                      @click.prevent="closeFolders"
                    >
                      <i class="fal fa-video"></i>&nbsp;&nbsp;{{
                        $t("MEETINGS.TITLE")
                      }}
                    </b-nav-item>
                  </div>
              </div>
            </div>
          </div>
  
        </b-nav>



      </div>
  </section>
</template>
<script>
export default {
  props: {
    functionbox_uuid: {
      default: "",
      type: String,
    },
    user_uuid: {
      default: "",
      type: String,
    },
    sefosEnabled: {
      type: Boolean,
      default: true,
    },
    showFolders: {
      type: Boolean,
      default: true,
    },
    isMobile: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      loading: false,
      currentPage: 1,
      redrawIndex: 0,
      items: [],
      selectedIndex: 0,
      totalItems: 0,
      state: 1,
    };
  },
  methods: {
    collapse(item) {
      let self = this;
      this.$http
        .post(this.user.hostname + "/user/functionbox/collapse", {
          account_id: this.user.information.id,
          functionbox_uuid: item.functionbox_uuid,
          collapsed: !item.collapse,
        })
        .then(function () {
          for (let ix = 0; ix < self.user.functionboxes.items.length; ix++) {
            if (self.user.functionboxes.items[ix].email == item.email) {
              self.user.functionboxes.items[ix].collapse = !item.collapse;
            }
          }
        })
        .catch(function () {});
    },
    collapseDelegatedBox(item) {
      let self = this;
      this.$http
        .post(this.user.hostname + "/user/delegatedbox/collapse", {
          account_id: this.user.information.id,
          user_uuid: item.user_uuid,
          collapsed: !item.collapse,
        })
        .then(function () {
          for (let ix = 0; ix < self.user.delegatedboxes.items.length; ix++) {
            if (self.user.delegatedboxes.items[ix].email == item.email) {
              self.user.delegatedboxes.items[ix].collapse = !item.collapse;
            }
          }
        })
        .catch(function () {});
    },
    ShowFunctionbox(item) {
      if (!this.sefosEnabled) {
        if (item.fax_enabled || item.sdk_enabled) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    closeFolders() {
      this.$emit("closeFolders");
    },
    delegatedKey(index) {
      return "delegated_" + index;
    },
    avatarInitials(item) {
      return (
        item.name.charAt(0).toUpperCase() +
        item.name.slice(item.name.length - 1).toUpperCase()
      );
    },
  },
  computed: {
  },
  watch: {
  },
  mounted: function() {    
  },
};
</script>
<style></style>
